




import Vue, { PropType } from 'vue';
import config from '@/config';
import fetcher from '@/fetcher';
import SearchView from './SearchView.vue';
import debounce from 'lodash/debounce';

enum ItemType {
  mall = 'mall',
  business = 'business',
}

interface IItem {
  id: string;
  type: ItemType;
  name: string;
  address: string;
}

export default Vue.extend({
  name: 'Search',
  data() {
    return {
      searchQuery: '',
      items: [] as PropType<IItem[]>,
      loading: false,
    };
  },
  watch: {
    searchQuery(): void {
      this.debouncedDoSearch();
    },
  },
  methods: {
    _doSearch() {
      const searchQuery = this.searchQuery;

      this.$router.replace({
        query: searchQuery ? { q: searchQuery } : undefined,
      });

      this.loading = true;

      fetcher(`${config.apiHost}/search`)
        .query({ q: searchQuery }) // query method encodes it
        .get()
        .json(data => {
          this.items = data.map((item: IItem) => {
            const idParam = {
              [ItemType.mall]: { mallId: item.id },
              [ItemType.business]: { bizId: item.id },
            };

            return {
              name: item.name,
              address: item.address,
              link: {
                name: item.type,
                params: idParam[item.type],
              },
            };
          });
        })
        .catch(() => {
          this.items = [];
        })
        .finally(() => {
          this.loading = false;
        });
    },
    debouncedDoSearch(): void {
      /** placeholder, overwritten in created */
    },
  },
  created(): void {
    const query = this.$route.query.q;
    const queryStr = Array.isArray(query) ? query[query.length - 1] : query;

    this.searchQuery = queryStr || '';

    this.debouncedDoSearch = debounce(this._doSearch, 300);
  },
  components: {
    SearchView,
  },
});
